export const LOGIN_REQUEST = 'LoginReducer/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LoginReducer/LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LoginReducer/LOGIN_FAILED';
export const CHANGE_INFO_REQUEST = 'LoginReducer/CHANGE_INFO_REQUEST';
export const CHANGE_INFO_SUCCESS = 'LoginReducer/CHANGE_INFO_SUCCESS';
export const CHANGE_INFO_FAILED = 'LoginReducer/CHANGE_INFO_FAILED';
export const LOGOUT = 'LoginReducer/LOGOUT';
